var ui = {
  toast: (text) => {
    let html =
      `
	        <div style="
	        position: fixed;
	        z-index:9999999;
	        top:50%;
	        left: 50%;
	        background:rgba(0,0,0,0.7);
	        color: #fff;
	        -webkit-transform: translate(-50%,-50%);
	        -ms-transform: translate(-50%,-50%);
	        transform: translate(-50%,-50%);
	        font-size: 16px;
	        padding: 11px 20px;
	        border-radius:4px;
	        transition:all 0.2s;
          height:auto;
	        ">` +
      text + `</div>
	        `
    let div = document.body.appendChild(document.createElement("div"));
    div.innerHTML = html;

    setTimeout(function() {
      div.style.opacity = 1;

    }, 1);
    setTimeout(function() {
      div.style.opacity = 0;
      setTimeout(function() {
        document.body.removeChild(div)
      }, 500);
    }, 2000)
  },
  alert(title, con, callback) {
    let html =
      `
        <div class="pop" style="z-index:{{zIndex}};" event_click="close">
          <div class="pop-con"  style="z-index:{{zIndex}};width:auto;">
            <div class="pop-title">
              <span>{{Title}}</span>
              <font class="pop-close" event_click="close"></font>
            </div>
            <div class="pop-info">
            	{{Con}}
            </div>
            <div class="pop-tool">
            	<span class="on"  event_click="define">确定</span>
            </div>

          </div>
        </div>
          `;
    if (!top.zIndex) top.zIndex = 9999;
    top.zIndex += 2;
    let div=document.body.appendChild(document.createElement("div"));
    div.innerHTML=html.replace(/\{\{zIndex\}\}/g, top.zIndex)
      .replace(/\{\{Title\}\}/g, title)
      .replace(/\{\{Con\}\}/g, con);

    div.querySelectorAll('[event_click="define"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div);
        callback && callback();
      }
    })
    div.querySelectorAll('[event_click="close"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div);
      }
    });
  },
  confirm(title, con, callback) {
    let html =
      `
      <div class="pop" style="z-index:{{zIndex}};" event_click="close">
        <div class="pop-con"  style="z-index:{{zIndex}};width:auto;">
          <div class="pop-title">
            <span>{{Title}}</span>
            <font class="pop-close" event_click="close"></font>
          </div>
          <div class="pop-info">
          	{{Con}}
          </div>
          <div class="pop-tool">
          	<span event_click="close">取消</span>
          	<span class="on"  event_click="define">确定</span>
          </div>

        </div>
      </div>
          `;
    if (!top.zIndex) top.zIndex = 9999;
    top.zIndex += 2;
    let div=document.body.appendChild(document.createElement("div"));
    div.innerHTML=html.replace(/\{\{zIndex\}\}/g, top.zIndex)
      .replace(/\{\{Title\}\}/g, title)
      .replace(/\{\{Con\}\}/g, con);


    div.querySelectorAll('[event_click="define"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div);
        callback && callback();
      }
    })
    div.querySelectorAll('[event_click="close"]').forEach((item) => {
      item.onclick = () => {
        document.body.removeChild(div);
      }
    });
  },
  layer: {
    open(path, title, width, height, callback, getcallback) {
      let html =
        `
        <div class="pop" style="z-index:{{zIndex}};" event_click="close">
        	<div class="pop-con"  style="z-index:{{zIndex}};">
        		<div class="pop-title">
        			<span>{{Title}}</span>
        			<font class="pop-close" event_click="close"></font>
        		</div>
        		<iframe src="{{Path}}" style="width:{{Width}}px;height:{{Height}}px;" scrolling="yes" frameborder="0"></iframe>
        	</div>
        </div>

        `;
      title = title || '弹出层';
      width = width || 800;
      height = height || 500;
      let funName = 'layer_' + Math.round(Math.random());
      path = path + (path.indexOf('?') > -1 ? '&' : '?') + 'LayerCallBack=' + funName;
      if (!top.zIndex) top.zIndex = 9999;
      top.zIndex += 2;
      let div=document.body.appendChild(document.createElement("div"));
      div.innerHTML=html.replace(/\{\{zIndex\}\}/g, top.zIndex)
        .replace(/\{\{Title\}\}/g, title)
        .replace(/\{\{Path\}\}/g, path)
        .replace(/\{\{Width\}\}/g, width)
        .replace(/\{\{Height\}\}/g, height);
      
      top[funName] = function(data, type) {
        if (data == null) {
          if (type == 'close') document.body.removeChild(div);
          else if (type == 'get') return getcallback && getcallback();
        } else {
          callback && callback(data);
        }
      }
      obj.get(0).querySelectorAll('[event_click="close"]').forEach((item) => {
        item.onclick = () => {
          document.body.removeChild(div);
        }
      });
    },
    close: function() {
      var fun = $.string.path(location.href)['LayerCallBack'];
      top[fun] && top[fun](null, 'close');
    },
    get: function() {
      var fun = $.string.path(location.href)['LayerCallBack'];
      return top[fun] && top[fun](null, 'get');
    },
    set: function(data) {
      var fun = $.string.path(location.href)['LayerCallBack'];
      top[fun] && top[fun](data);
    }
  }
}
export default ui;



// WEBPACK FOOTER //
// ./src/helpers/ui.js